export type ContainerScope = 'singleton' | 'container' | 'transient';
